module.exports = __webpack_public_path__ + "img/37.4c49499.jpg";